import { forwardRef } from 'react'
import type { ElementRef } from 'react'

import { CheckIcon, CopyIcon } from '@radix-ui/react-icons'

import useClipboard from 'hooks/use-clipboard'

import Box from 'components/atomic/atoms/box'
import { IconStyled } from 'components/atomic/atoms/icon'
import Input, { InputProps } from 'components/atomic/atoms/input'

const NAME = 'InputCopy'

const InputCopy = forwardRef<ElementRef<typeof Box>, InputProps>(
  (props, forwardedRef) => {
    const { onCopy, hasCopied } = useClipboard()

    return (
      <Box relative ref={forwardedRef} css={{ width: '$full' }}>
        <Input
          {...props}
          readOnly
          css={{
            pr: '$14',
            ...props.css,
          }}
        />
        <Box
          as="button"
          onClick={() => onCopy(props?.value as string)}
          absolute
          flex
          items="center"
          justify="center"
          css={{
            cursor: 'pointer',
            top: 0,
            right: '$0',
            height: '$full',
            px: '$4',
            color: '$text2',
            backgroundColor: '$transparent',
            width: 'fit-content',
            border: 'none',
            borderLeft: '1px solid $bg3',
          }}
        >
          <IconStyled as={hasCopied ? CheckIcon : CopyIcon} />
        </Box>
      </Box>
    )
  },
)

InputCopy.displayName = NAME

export default InputCopy
